var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlankCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.45703C0 4.23406 4.23406 0 9.45703 0C14.68 0 18.9141 4.23406 18.9141 9.45703C18.9141 14.68 14.68 18.9141 9.45703 18.9141C4.23406 18.9141 0 14.68 0 9.45703Z",
    fill: "#262626"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankCircle);
export default __webpack_public_path__ + "static/media/BlankCircle.dd4081fff60b8faaf946b6b2a23e3a1a.svg";
export { ForwardRef as ReactComponent };